
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1231 -431)","fill":"#777"}},[_c('circle',{attrs:{"data-name":"Ellipse 372","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1231 431)"}}),_c('circle',{attrs:{"data-name":"Ellipse 377","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1236 431)"}}),_c('circle',{attrs:{"data-name":"Ellipse 373","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1231 436)"}}),_c('circle',{attrs:{"data-name":"Ellipse 376","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1236 436)"}}),_c('circle',{attrs:{"data-name":"Ellipse 374","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1231 441)"}}),_c('circle',{attrs:{"data-name":"Ellipse 375","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1236 441)"}})])])
          )
        }
      }
    